var tallyPanelDisabled = false;
var crosstabPanelDisabled = false;

function DisableTallyPanel() {
	if (tallyPanelDisabled == false) {
		DisablePanel($('#divBasicSelections'));
		tallyPanelDisabled = true;
	}
}

function DisableCrosstabPanel() {
	if (crosstabPanelDisabled == false) {
		DisablePanel($('#divCrosstabSelections'));
		crosstabPanelDisabled = true;
	}
}
function DisablePanel(panel) {
	$(panel).each(function () {
		if (this.style != null) {
			if (this.originalColor == null) this.originalColor = this.style.color;
			this.style.color = "silver";
		}
	});
	$("input[type=radio], input[type=checkbox]", panel).each(function () { this.checked = false; });
	$("input[type=radio], input[type=checkbox]", panel).attr('disabled', true);
}
function ResetPanel(panel) {
	$("input[type=radio], input[type=checkbox]", panel).attr('disabled', false);
	$("input[type=radio], input[type=checkbox]", panel).each(function () { this.checked = false; });
	$(panel).each(function () {
		if (this.style != null) {
			if (this.originalColor != null)
				this.style.color = this.originalColor;
		}
	});
}

function ResetReportSelections() {
	ResetPanel('#divBasicSelections');
	ResetPanel('#divCrosstabSelections');
	crosstabPanelDisabled = false;
	tallyPanelDisabled = false;
}
function SubmitMarketResearchReport() {
	var theForm = $('#MarketResearchReport');
	theForm.unbind('submit');
	theForm.submit(function () {
		$.DotComAjax({
			url: theForm.attr('action'),
			cache: false,
			context: theForm,
			type: 'POST',
			data: theForm.serialize(),
			target: theForm,
			beforeSend: function () {
				//alert('doin it');
			},
			success: function (data) {
				//					if (IsDefined(onSuccess) && typeof onSuccess === 'function') {
				//						onSuccess();
				//					}
				var good = data.success;
				if (good)
				{ RedirectToThankYouPage(data); }
				else
				{ DisplayValidationErrors(data.Errors); }
			},
			async: true
		});
		return false;
	}).submit();
}
function RedirectToThankYouPage(data) {
	window.location.replace(data.RedirectUrl);
}